import React from "react";

import Badge from "shared/components/Badge/Badge";
import { BadgeTypes, BadgeCategory } from "shared/types/badge";

import styles from "./Badges.module.scss";
import Grid from "@material-ui/core/Grid";

interface IBadge {
  type: BadgeTypes;
  label: string;
  description?: string;
}

interface ICategory {
  badges: IBadge[];
  category: BadgeCategory;
  heading?: string;
}

const categories: ICategory[] = [
  {
    heading: "Feedback Badges",
    category: BadgeCategory.feedback,
    badges: [
      {
        type: BadgeTypes.bronze,
        label: "Enlightened",
        description: "Feedback with score of 2",
      },
      {
        type: BadgeTypes.silver,
        label: "Reviewer",
        description: "Feedback with score of 4",
      },

      {
        type: BadgeTypes.gold,
        label: "Guru",
        description: "Feedback with score of 8",
      },
      {
        type: BadgeTypes.diamond,
        label: "Illuminator",
        description: "Feedback with score of 12",
      },
    ],
  },

  {
    heading: "Solution Badges",
    category: BadgeCategory.solution,
    badges: [
      {
        type: BadgeTypes.bronze,
        label: "Beloved",
        description: "Have 2 likes to your solution",
      },

      {
        type: BadgeTypes.silver,
        label: "Perfection",
        description: "Have 5 likes to your solution",
      },

      {
        type: BadgeTypes.gold,
        label: "Epic",
        description: "Have 10 likes to your solution",
      },

      {
        type: BadgeTypes.diamond,
        label: "Legandary",
        description: "Have 20 likes to your solution",
      },
    ],
  },

  {
    heading: "Participant Badges",
    category: BadgeCategory.participant,
    badges: [
      {
        type: BadgeTypes.bronze,
        label: "Tutor",
        description: "Leave 3 feedback",
      },

      {
        type: BadgeTypes.silver,
        label: "Feedbacker",
        description: "Leave 10 feedback",
      },

      {
        type: BadgeTypes.gold,
        label: "Teacher",
        description: "Leave 15 feedback",
      },

      {
        type: BadgeTypes.diamond,
        label: "Professor",
        description: "Leave 25 feedback",
      },

      {
        type: BadgeTypes.bronze,
        label: "Solver",
        description: "Submit a Beginner Solution",
      },

      {
        type: BadgeTypes.silver,
        label: "Challenge Crusher",
        description: "Submit an Elementary Solution",
      },

      {
        type: BadgeTypes.gold,
        label: "Solution Expert",
        description: "Submit an Intermediate Solution",
      },

      {
        type: BadgeTypes.diamond,
        label: "Solution Hero",
        description: "Submit an Upper Intermediate or Advanced Solution",
      },

      {
        type: BadgeTypes.gold,
        label: "Weekly Populist",
        description: "Top 5 highest popularity score of the week",
      },

      {
        type: BadgeTypes.diamond,
        label: "Monthy Populist",
        description: "Top 5 highest popularity score of the month",
      },
    ],
  },

  // {
  //   heading: "Patreon Badges",
  //   category: BadgeCategory.patreon,
  //   badges: [
  //     {
  //       type: BadgeTypes.bronze,
  //       label: "Supporter",
  //       description: "Donate 1 euros per month",
  //     },

  //     {
  //       type: BadgeTypes.silver,
  //       label: BadgeNames.Honor,
  //       description: "Donate 5 euros per month",
  //     },

  //     {
  //       type: BadgeTypes.gold,
  //       label: "Marvelouser",
  //       description: "Donate 10 euros per month",
  //     },

  //     {
  //       type: BadgeTypes.diamond,
  //       label: BadgeNames.DiamondSupporter,
  //       description: "Donate 20 euros or more per month",
  //     },
  //   ],
  // },
  {
    heading: "Penalty Badges",
    category: BadgeCategory.penalty,
    badges: [
      {
        type: BadgeTypes.penalty,
        label: "Uncontructive",
        description: "Your feedback is downvoted 5 times",
      },

      {
        type: BadgeTypes.penaltyTwo,
        label: "Spam",
        description: "One of your solution or feedback receives 6 spams",
      },
    ],
  },
];

const Badges = () => {
  return (
    <Grid container direction="row" spacing={2}>
      <Grid item xs={12} sm={8} md={9}>
        <div>
          <h2>Badges</h2>
          <p>
            Besides requiring certificates when you complete a path, you receive
            badges and reputations points for being active. Badges and
            reputations points appear on your profile page, feedback, and your
            solutions.
          </p>

          <h2 style={{ marginBottom: 0, marginTop: "var(--space-2xl)" }}>
            All Badges
          </h2>

          {categories.map(({ heading, badges, category }) => (
            <div key={category} className={styles.badges_category}>
              <h4>{heading}</h4>

              {badges.map(({ type, label, description }) => (
                <div key={label} className={styles.badges_badgeWrapper}>
                  <Grid container direction="row" spacing={2}>
                    <Grid item xs={12} sm={5} md={3}>
                      <Badge type={type} label={label} category={category} />
                    </Grid>

                    <Grid item xs={12} sm={7} md={9}>
                      <div className={styles.badges_description}>
                        {description}
                      </div>
                    </Grid>
                  </Grid>
                </div>
              ))}
            </div>
          ))}
        </div>
      </Grid>

      <Grid item xs={12} sm={4} md={3}>
        <div className={styles.badges_summary}>
          <h4>Badge Types</h4>

          <div>
            <Badge
              type={BadgeTypes.bronze}
              label="Bronze Badge"
              category={BadgeCategory.participant}
            />

            <p>Add 2 points to reputations.</p>
          </div>

          <div>
            <Badge
              type={BadgeTypes.silver}
              label="Silver Badge"
              category={BadgeCategory.participant}
            />

            <p>Add 10 points to reputations.</p>
          </div>

          <div>
            <Badge
              type={BadgeTypes.gold}
              label="Gold Badge"
              category={BadgeCategory.participant}
            />

            <p>Add 20 points to reputations.</p>
          </div>

          <div>
            <Badge
              type={BadgeTypes.diamond}
              label="Diamond Badge"
              category={BadgeCategory.participant}
            />

            <p>Add 50 points to reputations.</p>
          </div>

          <div>
            <Badge
              type={BadgeTypes.penalty}
              label="Penalty Badge"
              category={BadgeCategory.participant}
            />

            <p>Deduct 10 points to reputations.</p>
          </div>

          <div>
            <Badge
              type={BadgeTypes.penaltyTwo}
              label="Penalty Two Badge"
              category={BadgeCategory.participant}
            />

            <p>Deduct 100 points to reputations.</p>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default Badges;
